import { createContext } from 'react';

export const AddToCartContext = createContext(
  (productId: number, productQuantity?: number) => {}
);
